export const SetupEndpoints = {
  setLogo: '/setup/logo',
  setup: '/setup',
};
